import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { useNavigate } from "react-router-dom";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';

import { useDispatch, useSelector } from "react-redux";
import { fetchDriversData } from "../../store/drivers/actions";

const Drivers = props => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { data, loading, error } = useSelector(state => state.Drivers);

    useEffect(() => {
        dispatch(fetchDriversData());
      }, [dispatch]);

    const columns = useMemo(
        () => [
          {
            header: "Image",
            accessorKey: "profile_pic",
            enableColumnFilter: false,
            cell: ({ row }) => (
              <img
                src={row.original.profile_pic || "assets/images/no-image.png"}
                alt="Profile"
                style={{ width: 40, height: 40, borderRadius: "50%" }}
              />
            )
          },
          {
            header: 'Name',
            accessorKey: 'name',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Email',
            accessorKey: 'email',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Phone',
            accessorKey: 'phone',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Status',
            accessorKey: 'status',
            enableColumnFilter: false,
            enableSorting: true,
            cell: ({ row }) => {
              const status = row.original.status?.toLowerCase();
              const isOnline = status == 'online';

              return (
                <span className={`badge ${isOnline ? 'bg-success' : 'bg-danger'}`}>
                  {status ? status.charAt(0).toUpperCase() + status.slice(1) : 'Offline'}
                </span>
              );
            }
          },
          {
            header: 'Is Active?',
            accessorKey: 'is_active',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Actions',
            accessorKey: 'actions',
            enableColumnFilter: false,
            enableSorting: false,
            cell: ({ row }) => {
              const driverId = row.original?.driverId;
              return (
                <button
                  className="btn btn-sm btn-success"
                  onClick={() => navigate(`/drivers/${driverId}`)}
                >
                  <i className="mdi mdi-eye"></i> View
                </button>
              );
            },
          }
        ],
        [navigate]
      );

    const totalRecords = data?.data?.length ?? 0;
    
    const transformedData = useMemo(() => {
      return data?.data?.map(item => {
          return {
              driverId: item.user_id,
              profile_pic: item.profile_pic || "assets/images/no-image.png",
              name: item.user_name || "N/A",
              email: item.email || "N/A",
              phone: item.phone_code + " " + item.mobno || "N/A",
              // status: item.status || "N/A",
              is_active: item.is_active == 1 ? 'YES' : 'NO' || "N/A",
          };
      }) ?? [];
    }, [data]);

    document.title = "Drivers | Moeen";
    return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="Drivers" />
        {loading ? (
        <Skeleton count={10} height={40} />
        ) : (
        <TableContainer
          columns={columns}
          data={transformedData || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder={`Looking for something? ${totalRecords} results loaded.`}
          pagination="pagination"
          paginationWrapper='dataTables_paginate paging_simple_numbers'
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      )}
      </div>
    </div>
  );
};

Drivers.propTypes = {
  t: PropTypes.any
};

export default Drivers;